export const CardPointeSurchargeTokenType = {
    CREDIT: 'CREDIT',
    DEBIT: 'DEBIT',
    UNKNOWN: 'UNKNOWN',
} as const;

export type CardPointeSurchargeTokenType =
    (typeof CardPointeSurchargeTokenType)[keyof typeof CardPointeSurchargeTokenType];

export const CardPointeSurchargePostalStatus = {
    RESTRICTED: 'RESTRICTED',
    NOT_RESTRICTED: 'NOT_RESTRICTED',
    UNKNOWN: 'UNKNOWN',
} as const;

export type CardPointeSurchargePostalStatus =
    (typeof CardPointeSurchargePostalStatus)[keyof typeof CardPointeSurchargePostalStatus];

export interface CardPointeSurchargeResponseBody {
    readonly [field: string]: unknown;
    readonly token: CardPointeSurchargeTokenType;
    readonly postal: CardPointeSurchargePostalStatus;
    readonly fee_amount?: string;
}
